
export const cloudfrontUrl = `${process.env.REACT_APP_CLOUDFRONT_URL}/products`